import { createContext, useContext } from 'react'

export const InlineSettingsContext = createContext(false)

export const useInlineSettings = () => useContext(InlineSettingsContext)
